export default "__VITE_ASSET__0296c90b__"